import { useTranslations } from "next-intl";
import { NoxusTooltip } from "@/components/UI/NoxusTooltip";
import { StatusIcon } from "@/components/Spotflow/WorkflowRunner/Outputs/ExpandableNode/StatusIcon";
import { CheckResult, RunStatus, TestCaseReport } from "@/generated";

type Outcome = TestCaseReport["outcome"];

const NODE_STATUS: Record<Outcome, string> = {
  passed: "succeeded",
  failed: "errored",
  error: "warning",
  not_run: "skipped",
  running: "running",
  cancelled: "skipped",
};

export function OutcomeIcon({ outcome }: { outcome: Outcome }) {
  const t = useTranslations("agentTests");
  const nodeStatus = NODE_STATUS[outcome];
  const label = t(`outcomes.${outcome}`);
  return (
    <NoxusTooltip content={label} asChild>
      <span role="img" aria-label={label} className="inline-flex">
        <StatusIcon
          nodeStatus={nodeStatus}
          runStatus={
            outcome === "running" ? RunStatus.RUNNING : RunStatus.COMPLETED
          }
        />
      </span>
    </NoxusTooltip>
  );
}

export function CheckIcon({ check }: { check: CheckResult }) {
  if (check.status === "completed" && check.passed !== null) {
    return <OutcomeIcon outcome={check.passed ? "passed" : "failed"} />;
  }
  if (check.status === "failed") {
    return <OutcomeIcon outcome="error" />;
  }
  if (check.status === "cancelled") {
    return <OutcomeIcon outcome="cancelled" />;
  }
  if (check.status === "pending" || check.status === "running") {
    return <OutcomeIcon outcome="running" />;
  }
  return <OutcomeIcon outcome="not_run" />;
}
